import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Typography,
  Paper,
  Card,
  CardContent,
  Grid,
  Container,
} from '@mui/material';
import {
  LocationOn as LocationIcon,
  People as PeopleIcon,
  Security as SecurityIcon,
} from '@mui/icons-material';

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  const quickActions = [
    {
      title: t('locations.title'),
      description: t('home.locationsDescription'),
      icon: <LocationIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
      path: '/locations',
    },
    {
      title: t('clients.title'),
      description: t('home.clientsDescription'),
      icon: <PeopleIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
      path: '/clients',
    },
    {
      title: t('navigation.settings'),
      description: t('home.settingsDescription'),
      icon: <SecurityIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
      path: '/settings',
    },
  ];

  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4, mb: 4 }}>
        {/* Welcome Header */}
        <Paper elevation={2} sx={{ p: 4, mb: 4, textAlign: 'center' }}>
          <Typography variant="h3" component="h1" gutterBottom color="primary">
            {t('home.welcome')}
          </Typography>
          <Typography variant="h5" component="h2" gutterBottom color="text.secondary">
            {t('navigation.adminPanel')}
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
            {t('home.systemDescription')}
          </Typography>
        </Paper>

        {/* Quick Actions */}
        <Typography variant="h4" component="h2" gutterBottom sx={{ mb: 3 }}>
          {t('home.quickActions')}
        </Typography>
        <Grid container spacing={3}>
          {quickActions.map((action, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card 
                sx={{ 
                  height: '100%',
                  cursor: 'pointer',
                  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 4,
                  },
                }}
                onClick={() => navigate(action.path)}
              >
                <CardContent sx={{ textAlign: 'center', p: 3 }}>
                  <Box sx={{ mb: 2 }}>
                    {action.icon}
                  </Box>
                  <Typography variant="h6" component="h3" gutterBottom>
                    {action.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {action.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* System Information */}
        <Paper elevation={1} sx={{ p: 3, mt: 4 }}>
          <Typography variant="h5" component="h3" gutterBottom>
            {t('home.systemOverview')}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {t('home.systemDescription')}
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default HomePage; 